/* unplugin-vue-components disabled */import { render } from "./IfasCardHeaderButton.vue?vue&type=template&id=3ccdad06"
import script from "./IfasCardHeaderButton.vue?vue&type=script&lang=js"
export * from "./IfasCardHeaderButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__